(ns frontend.ui.page.lp-report-editor.step-6-publishing-queue.event
  (:require
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.ui.page.lp-report-editor.event :as editor-event]))


(rf/reg-event-fx
 ::reset
 (fn [{db :db} _]
   {:db (assoc-in db [:lp-report-editor :approve] nil)}))

(rf/reg-event-fx
 ::force-publish-ok
 (fn [{db :db} [_ investor-identifier resp]]
   {:db (-> db
            (assoc-in [:lp-report-editor :lp-report :lp-report/step] :lp-report.step/published))
    :fx [[:dispatch [::editor-event/activate-step :lp-report.step/published]]]}))

(rf/reg-event-fx
 ::force-publish-failed
 (fn [{db :db} [_ err]]
   (js/console.log "Force publish failed : " err)))

(rf/reg-event-fx
 ::force-publish
 (fn [{db :db} [_ report-id]]
   {::ws/send {:id         :lp-report/force-publish
               :body       {:report-id report-id}
               :on-success [::force-publish-ok report-id]
               :on-error   [::force-publish-failed report-id]}}))
